import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./PaymentPageVisionIgniteAscend.css";

const SERVICE_NAME =
  "Forge Your Peak - Vision Ignite Ascend";

const PRODUCT_PRICE = 49999;

const PaymentPageVisionIgniteAscend = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const navbar = document.querySelector(
      "header, .navbar"
    );
    const footer = document.querySelector("footer");

    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";

    return () => {
      if (navbar) navbar.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhoneChange = (phone) => {
    setFormData((prev) => ({
      ...prev,
      phone,
    }));
  };

  const handlePayment = async () => {
    try {
      if (!formData.name.trim()) {
        alert("Please enter your full name.");
        return;
      }

      if (!formData.email.trim()) {
        alert("Please enter your email address.");
        return;
      }

      if (!formData.phone.trim()) {
        alert("Please enter your phone number.");
        return;
      }

      if (!window.Razorpay) {
        alert("Razorpay checkout is not loaded.");
        return;
      }

      setIsLoading(true);

      // ============================================
      // CREATE ORDER
      // ============================================

      const response = await axios.post(
        "/api/razorpay/create-order",
        {
          name: formData.name.trim(),
          email: formData.email
            .trim()
            .toLowerCase(),
          phone: formData.phone,
          service: SERVICE_NAME,
        }
      );

      const data = response.data;

      if (!data.success) {
        throw new Error(
          data.message ||
            "Unable to create payment order."
        );
      }

      // ============================================
      // RAZORPAY CHECKOUT
      // ============================================

      const options = {
        key: data.keyId,

        amount: data.order.amount,

        currency: data.order.currency,

        name: "Forge Your Peak",

        description: SERVICE_NAME,

        order_id: data.order.id,

        prefill: {
          name: formData.name.trim(),
          email: formData.email
            .trim()
            .toLowerCase(),
          contact: formData.phone,
        },

        notes: {
          service: SERVICE_NAME,
        },

        theme: {
          color: "#20264F",
        },

        // ==========================================
        // SUCCESS
        // ==========================================

        handler: async (paymentResponse) => {
          try {
            const verifyResponse =
              await axios.post(
                "/api/razorpay/verify-payment",
                {
                  razorpay_order_id:
                    paymentResponse.razorpay_order_id,

                  razorpay_payment_id:
                    paymentResponse.razorpay_payment_id,

                  razorpay_signature:
                    paymentResponse.razorpay_signature,
                }
              );

            const verifyData =
              verifyResponse.data;

            if (!verifyData.success) {
              throw new Error(
                verifyData.message ||
                  "Payment verification failed."
              );
            }

            console.log(
              "✅ Vision Ignite Ascend payment verified",
              verifyData.user
            );

            // ========================================
            // META PURCHASE
            // ========================================

            if (window.fbq) {
              window.fbq(
                "trackSingle",
                process.env.REACT_APP_META_PIXEL_ID ||
                  "2060088607979588",
                "Purchase",
                {
                  content_category:
                    "Vision Ignite Ascend",
                  content_name: SERVICE_NAME,
                  value: PRODUCT_PRICE,
                  currency: "INR",
                }
              );
            }

            setIsLoading(false);

            alert(
              "Payment successful! Your access has been activated."
            );

            // ========================================
            // DASHBOARD LOGIN
            // ========================================

            navigate("/dashboard-login", {
              replace: true,
            });

          } catch (error) {
            console.error(
              "❌ Payment verification error:",
              error
            );

            setIsLoading(false);

            alert(
              error.response?.data?.message ||
                error.message ||
                "Payment verification failed. Please contact support."
            );
          }
        },

        // ==========================================
        // CHECKOUT CLOSED
        // ==========================================

        modal: {
          ondismiss: () => {
            setIsLoading(false);
          },
        },
      };

      const razorpay =
        new window.Razorpay(options);

      // ============================================
      // PAYMENT FAILED
      // ============================================

      razorpay.on(
        "payment.failed",
        (response) => {
          console.error(
            "❌ Payment failed:",
            response.error
          );

          setIsLoading(false);

          alert(
            response.error?.description ||
              "Payment failed. Please try again."
          );
        }
      );

      razorpay.open();

    } catch (error) {
      console.error(
        "❌ Payment initialization error:",
        error
      );

      setIsLoading(false);

      alert(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong while starting the payment."
      );
    }
  };

  return (
    <div className="via-payment-page">

      {/* =========================================
          LEFT
      ========================================= */}

      <section className="via-payment-left">

        <div className="via-left-inner">

          <div className="via-company-logo">
            <img
              src="/Logo.png"
              alt="Forge Your Peak"
            />
          </div>

          <div className="via-product-header">

            <h1>
              Forge Your Peak -
              <br />
              Vision Ignite Ascend
            </h1>

            <p>
              By ForgeYourPeak
            </p>

            <div className="via-product-price">
              ₹49,999
            </div>

          </div>

          <div className="via-product-description">

            <p className="via-intro">
              A 90-day personalized vision
              coaching program designed to
              help you improve visual comfort,
              focus, eye movement, and the way
              your visual system responds to
              everyday demands.
            </p>

            <p>
              Vision Ignite Ascend takes the
              Vision Ignite system to a more
              personalized level, combining a
              structured 90-day vision program
              with direct guidance and
              accountability.
            </p>

            <p>
              While Vision Ignite provides the
              foundation and daily visual routines,
              Ascend is designed around your
              individual visual needs, progress,
              and goals.
            </p>

            <p>
              Through personalized guidance,
              regular progress reviews, and
              structured visual training, you'll
              work on the areas that may be
              limiting your visual comfort and
              performance.
            </p>

            <h2>
              What is included?
            </h2>

            <ul>
              <li>
                Complete Vision Ignite curriculum
              </li>

              <li>
                90-day personalized vision
                training program
              </li>

              <li>
                Personalized visual performance
                roadmap
              </li>

              <li>
                Guided eye movement and focus
                practices
              </li>

              <li>
                Individual progress assessment
              </li>

              <li>
                Regular 1-on-1 coaching and
                guidance
              </li>

              <li>
                Personalized visual training
                recommendations
              </li>

              <li>
                Progress tracking and performance
                dashboard
              </li>

              <li>
                Streak and milestone-based
                progression
              </li>

              <li>
                Direct feedback and accountability
              </li>

              <li>
                Priority support
              </li>
            </ul>

            <h2>
              The Outcome
            </h2>

            <p>
              Over 90 days, you'll build a
              personalized visual training routine
              based on your individual needs and
              progress.
            </p>

            <p>
              You'll develop greater awareness
              of your visual habits, improve
              consistency with your training, and
              work toward better visual comfort,
              focus, eye movement, and visual
              endurance.
            </p>

            <p>
              Vision Ignite Ascend is designed
              for people who want to go beyond a
              self-guided vision program and
              receive personalized guidance
              throughout their visual performance
              journey.
            </p>

          </div>

        </div>

      </section>

      {/* =========================================
          RIGHT
      ========================================= */}

      <section className="via-payment-right">

        <div className="via-payment-right-inner">

          <h2>
            Payment details
          </h2>

          <p className="via-payment-subtitle">
            Complete your purchase by providing
            your payment details.
          </p>

          <div className="via-billing-card">

            <h3>
              Billing information
            </h3>

            <div className="via-billing-fields">

              <input
                type="text"
                name="name"
                placeholder="Full name"
                value={formData.name}
                onChange={handleChange}
                disabled={isLoading}
              />

              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
                disabled={isLoading}
              />

              <div className="via-phone-wrapper">

                <PhoneInput
                  country="in"
                  value={formData.phone}
                  onChange={handlePhoneChange}
                  enableSearch={true}
                  countryCodeEditable={false}
                  placeholder="Phone number"
                  inputProps={{
                    name: "phone",
                    required: true,
                  }}
                  containerClass="via-phone-container"
                  inputClass="via-phone-input"
                  buttonClass="via-phone-button"
                  dropdownClass="via-phone-dropdown"
                  disabled={isLoading}
                />

              </div>

            </div>

          </div>

          <div className="via-order-card">

            <div className="via-order-top-line"></div>

            <div className="via-order-content">

              <h3>
                Service
              </h3>

              <div className="via-service-row">

                <span>
                  Forge Your Peak -
                  Vision Ignite Ascend
                </span>

                <strong>
                  ₹49999.00
                </strong>

              </div>

              <div className="via-divider"></div>

              <div className="via-total-row">

                <span>
                  Amount to be paid :
                </span>

                <strong>
                  ₹49999.00
                </strong>

              </div>

            </div>

          </div>

          <button
            type="button"
            className="via-pay-button"
            onClick={handlePayment}
            disabled={isLoading}
          >
            {isLoading
              ? "Processing..."
              : "Proceed to pay ₹49999.00"}
          </button>

        </div>

      </section>

    </div>
  );
};

export default PaymentPageVisionIgniteAscend;